module.exports = __webpack_public_path__ + "img/04.4c3f07b6.png";